import { useTranslation } from 'react-i18next'
import { cn } from '@/shared/lib/utils'

const PLR_COLOR_CLASSES: Record<string, string> = {
  plA: 'bg-emerald-500 text-white',
  plB: 'bg-lime-500 text-white',
  plC: 'bg-yellow-500 text-black',
  plD: 'bg-orange-500 text-white',
  plE: 'bg-red-500 text-white',
}

const PLR_DOT_CLASSES: Record<string, string> = {
  plA: 'bg-emerald-500',
  plB: 'bg-lime-500',
  plC: 'bg-yellow-500',
  plD: 'bg-orange-500',
  plE: 'bg-red-500',
}

export function getPlrDotClass(plr: string | null | undefined): string {
  if (plr != null && PLR_DOT_CLASSES[plr] != null) {
    return PLR_DOT_CLASSES[plr]
  }
  return 'bg-muted-foreground/40'
}

type PlrBadgeProps = {
  plr: string | null | undefined
  className?: string
}

export function PlrBadge({ plr, className }: PlrBadgeProps) {
  const { t } = useTranslation('machineryDirectiveCompliance')

  if (plr == null || plr.trim() === '') {
    return (
      <span
        className={cn(
          'inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium text-muted-foreground',
          className
        )}
      >
        {t('safetyFunctionsPage.noPlr')}
      </span>
    )
  }

  const colorClass = PLR_COLOR_CLASSES[plr] ?? 'bg-muted text-foreground'
  const label = t(`safetyFunctionsPage.enums.plr.${plr}`, { defaultValue: plr })

  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold',
        colorClass,
        className
      )}
    >
      {label}
    </span>
  )
}
